module.exports = __webpack_public_path__ + "img/tours_2.11fe09da.jpg";